"use client"
import React, { useRef } from 'react'
import { FeaturesSectionDemo } from './Cards'
import { BgLines } from './background-lines'
import { motion, useInView } from 'framer-motion'
export const AboutUs = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  return (
    <div className="max-w-7xl mx-auto ">
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0 }}
        className='flex flex-col items-start justify-center max-w-4xl py-32 md:py-40 px-6 md:px-10 gap-5 mx-auto'>
        <span className='eyebrow'>Who We Are</span>
        <span className='text-3xl md:text-5xl font-bold text-white tracking-tight'>
          About Us
        </span>
        <span className='text-base md:text-lg text-slate-300 md:w-full leading-relaxed'>

          <section className="about-section space-y-6">

            <p>
              Founded in 2017 and headquartered in Karachi, Pakistan,
              <strong className="text-white"> Nubit Software (Pvt) Ltd</strong> is a leading
              technology company delivering custom software solutions, web and mobile
              application development (iOS & Android), and BPO services with a strong
              focus on financial services. We operate at the intersection of
              IT/technology and financial services, driving digital transformation
              and innovation across both sectors.
            </p>

            <p>
              Nubit Software has established itself as a trusted technology and
              business partner, combining deep industry expertise with cutting-edge
              solutions to deliver scalable, secure, and high-performance services
              tailored to evolving business needs.
            </p>

            {/* Achievements */}
            <div className="pt-6 space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                Achievements
              </h2>

              <ul className="space-y-4">
                <li className="card-premium rounded-xl p-5">
                  <strong className="text-white block mb-1">
                    2025 ASOCIO HealthTech Award
                  </strong>
                  <p className="mt-1 text-slate-300">
                    Recognized by the Asian-Oceanian Computing Industry Organisation (ASOCIO)
                    for leadership in digital healthcare innovation across Asia and Oceania.
                  </p>
                </li>

                <li className="card-premium rounded-xl p-5">
                  <strong className="text-white block mb-1">
                    2024 PSEB Award
                  </strong>
                  <p className="mt-1 text-slate-300">
                    Honored by the Pakistan Software Export Board (PSEB) for excellence
                    in IT and IT-enabled services, reflecting our contribution to innovation,
                    efficiency, and high-quality digital solutions in Pakistan’s technology ecosystem.
                  </p>
                </li>
              </ul>
            </div>
            {/* Industry Engagement */}
            <div className="pt-6 space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold text-white">
                Industry Engagement
              </h2>

              <p>We maintain active engagement with leading industry associations and regulatory institutions in Pakistan, including:</p>

              <ul className="list-disc pl-6 space-y-2 text-slate-300">
                <li>Karachi Chamber of Commerce & Industry (KCCI)</li>
                <li>Pakistan Software Houses Association (P@SHA)</li>
                <li>Pakistan Software Export Board (PSEB)</li>
                <li>Securities and Exchange Commission of Pakistan (SECP)</li>
              </ul>

              <p>
                Our engagement with these organizations reflects our commitment to staying aligned with Pakistan’s evolving business, technology, and regulatory environment.
              </p>
            </div>

          </section>
        </span>
      </motion.div>

      <FeaturesSectionDemo />

      {/* <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 60 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        className="flex flex-col items-center justify-center text-center max-w-3xl mx-auto py-24 px-6 gap-6"
      >
        <span className="text-sm md:text-base font-semibold tracking-[0.2em] text-blue-500 uppercase">
          Why Choose Us
        </span>

        <h2 className="text-2xl md:text-5xl font-bold leading-tight bg-gradient-to-r from-white via-gray-300 to-gray-500 text-transparent bg-clip-text">
          We help high-growth companies build and launch products faster
        </h2>

        <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-2xl">
          Our experienced teams guide companies through the complete product journey — from idea validation to scalable launch with modern technologies.
        </p>
      </motion.div> */}
      <motion.div
        ref={ref}
        initial={{ opacity: 0, x: -80 }}
        animate={isInView ? { opacity: 1, x: 0 } : {}}
        transition={{ duration: 0.6 }}
        className="flex flex-col items-start justify-center max-w-4xl mx-auto py-20 md:py-24 px-6 gap-5"
      >
        <span className="eyebrow">
          Why Choose Us
        </span>

        <h2 className="text-2xl md:text-4xl font-bold text-white leading-snug">
          Our experienced teams guide high-growth companies through the product journey
        </h2>

        <p className="text-slate-400 text-base md:text-lg leading-relaxed">
          From ideation to launch, we build scalable, efficient, and modern digital products tailored for growth.
        </p>
      </motion.div>
      {/* <ImagesSliderDemo/> */}
      <div >
        <BgLines />
      </div>
    </div>
  )
}
